
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/more",
      function () {
        return require("private-next-pages/more.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/more"])
      });
    }
  